import axios from 'utils/axios';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: {
    isLoading: false,
    error: false,
    data: [],
    count: 0,
  },
  detail: {
    isLoading: false,
    error: false,
    data: null,
  },
};

const slice = createSlice({
  name: 'consumptionRequests',
  initialState,
  reducers: {
    // List loading
    startLoadingList(state) {
      state.list.isLoading = true;
    },
    hasErrorList(state, action) {
      state.list.isLoading = false;
      state.list.error = action.payload;
    },
    getConsumptionRequestsSuccess(state, action) {
      state.list.isLoading = false;
      state.list.data = action.payload.consumptionRequests;
      state.list.count = action.payload.count;
    },

    // Detail loading
    startLoadingDetail(state) {
      state.detail.isLoading = true;
    },
    hasErrorDetail(state, action) {
      state.detail.isLoading = false;
      state.detail.error = action.payload;
    },
    getConsumptionRequestDetailSuccess(state, action) {
      state.detail.isLoading = false;
      state.detail.data = action.payload;
    },
    updateConsumptionRequestSuccess(state, action) {
      state.detail.isLoading = false;
      state.detail.data = action.payload;

      // Also update the item in the list
      const index = state.list.data.findIndex((request) => request.id === action.payload.id);
      if (index !== -1) {
        state.list.data[index] = action.payload;
      }
    },
  },
});

export default slice.reducer;

export function getConsumptionRequests(appId, page = 0, pageSize = 10, search = []) {
  return async (dispatch) => {
    const searchQuery = search.length > 0 ? `&search=${JSON.stringify(search)}` : '';
    dispatch(slice.actions.startLoadingList());
    try {
      const response = await axios.get(
        `/revenue-management/${appId}/consumption-requests?order=createdAt${searchQuery}&ordering=desc&page=${page}&limit=${pageSize}`,
      );

      dispatch(slice.actions.getConsumptionRequestsSuccess(response));
    } catch (error) {
      console.error('Error fetching consumption requests:', error);
      dispatch(slice.actions.hasErrorList(error));
    }
  };
}

export function getConsumptionRequestDetail(appId, requestId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoadingDetail());
    try {
      const response = await axios.get(`/revenue-management/${appId}/consumption-requests/${requestId}`);
      dispatch(slice.actions.getConsumptionRequestDetailSuccess(response));
    } catch (error) {
      console.error('Error fetching consumption request detail:', error);
      dispatch(slice.actions.hasErrorDetail(error));
    }
  };
}

export function updateConsumptionRequest(appId, requestId, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoadingDetail());
    try {
      const response = await axios.post(`/revenue-management/${appId}/consumption-requests/${requestId}/update`, data);
      dispatch(slice.actions.updateConsumptionRequestSuccess(response));
      return { success: true };
    } catch (error) {
      console.error('Error updating consumption request:', error);
      dispatch(slice.actions.hasErrorDetail(error));
      return { success: false, error };
    }
  };
}
